import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { ImproveWhatsappTemplateResponseData, ImproveWhatsappTemplateSchema } from "schema"
import z from "zod"

export const useImproveWhatsappTemplateMutation = () => {
  return useMutation({
    mutationFn: async (payload: z.infer<typeof ImproveWhatsappTemplateSchema>) => {
      const { data } = await axios.post<{
        data: z.infer<typeof ImproveWhatsappTemplateResponseData>
      }>(`/integrations/whatsapp/templates/improve`, payload)
      return data.data
    },
  })
}
